export default __webpack_public_path__ + "static/media/terraform-icon.14419943.svg";